import React, { Component } from "react";
import uuid from "react-uuid";
import axios from "axios";
import cloneDeep from "lodash.clonedeep";
import shortid from "shortid";
// VALID IMAGE VALIDATION
import { toast } from "react-toastify";

import { googleFonts, googleFontsEditor } from "./fonts";
import { tool } from "./tool";

var characterMap = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ả: "A",
  Ạ: "A",
  Ẩ: "A",
  Ẫ: "A",
  Ậ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ẻ: "E",
  Ẽ: "E",
  Ẹ: "E",
  Ể: "E",
  Ễ: "E",
  Ệ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ỉ: "I",
  Ị: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ỏ: "O",
  Ọ: "O",
  Ổ: "O",
  Ỗ: "O",
  Ộ: "O",
  Ờ: "O",
  Ở: "O",
  Ỡ: "O",
  Ớ: "O",
  Ợ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ủ: "U",
  Ụ: "U",
  Ử: "U",
  Ữ: "U",
  Ự: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ả: "a",
  ạ: "a",
  ẩ: "a",
  ẫ: "a",
  ậ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ẻ: "e",
  ẽ: "e",
  ẹ: "e",
  ể: "e",
  ễ: "e",
  ệ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ỉ: "i",
  ị: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ỏ: "o",
  ọ: "o",
  ổ: "o",
  ỗ: "o",
  ộ: "o",
  ờ: "o",
  ở: "o",
  ỡ: "o",
  ớ: "o",
  ợ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ủ: "u",
  ụ: "u",
  ử: "u",
  ữ: "u",
  ự: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  ß: "ss",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z",
  й: "j",
  Й: "j",
  ё: "е",
  Ё: "Е",
};

var chars = Object.keys(characterMap).join("|");
var allAccents = new RegExp(chars, "g");
var firstAccent = new RegExp(chars, "");

function matcher(match) {
  return characterMap[match];
}

var removeAccents = function (string) {
  return string.replace(allAccents, matcher);
};

var hasAccents = function (string) {
  return string.match(firstAccent);
};

export const urlHashSegmentFormat = (hashSegment) => {
  var newHashSegment = hashSegment.replace(
    /[&\/\#\]\[\\, !+()$~%&._'"`~|\-:;@^*?<>{}=]/g,
    ""
  );
  if (hasAccents(newHashSegment)) {
    newHashSegment = removeAccents(newHashSegment);
  }

  newHashSegment = newHashSegment.toLowerCase();
  return newHashSegment;
};

export { googleFonts, googleFontsEditor, tool };

export const checkMimeType = (event) => {
  //getting file object
  let files = event.target.files;
  //define message container
  let err = [];
  // list allow mime type
  const types = [
    "image/png",
    "image/jpeg",
    "image/gif",
    "video/mp4",
    "video/x-msvideo",
    "video/avi",
    "video/mov",
    "video/mpeg",
    "audio/mp3",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
  ];
  //const types = ['video/mp4']
  // loop access array
  for (var x = 0; x < files.length; x++) {
    // compare file type find doesn't matach
    if (types.every((type) => files[x].type !== type)) {
      // create error message and assign to container
      err[x] = files[x].type + " is not a supported format\n";
    }
  }
  for (var z = 0; z < err.length; z++) {
    // if message not same old that mean has error
    // discard selected file
    toast.error(err[z]);
    event.target.value = null;
  }
  return true;
};
// font-family: 'Great Vibes', cursive;

export const maxSelectFile = (event) => {
  let files = event.target.files;
  if (files.length > 4) {
    const msg = "Only 3 files can be uploaded at a time";
    event.target.value = null;
    toast.warn(msg);
    return false;
  }
  return true;
};
export const checkFileSize = (event) => {
  let files = event.target.files;
  let size = 2000000000000000;
  let err = [];
  for (var x = 0; x < files.length; x++) {
    if (files[x].size > size) {
      err[x] = files[x].type + " is too large, please pick a smaller file\n";
    }
  }
  for (var z = 0; z < err.length; z++) {
    // if message not same old that mean has error
    toast.error(err[z]);
    event.target.value = null;
  }
  return true;
};

export const NewCanvas = {
  title: null,
  description: null,
  meta_title: null,
  navClass: "default",
  containerBgColor: "#FFFFFF",
  containerWidth: 1200,
  selectedFont: "sans-serif",
  bgImage: "",
  bgImageId: "",
  bgVideo: "",
  bgType: "",
  colorsGlobal: [],
  layout: [],
  preset: [],
  imagesGlobal: [],
  percentage: false,
  pixel: true,
  bgImageIndex: "",
  editTextIndex: "",
  reloadAPI: false,
  layoutList: [["home", []]],
  layoutTitle: "home",
  layoutLanguages: ["en"],
  anchorNavigation: {
    enable: false,
    sticky: false,
    page: "home",
    tabs: [],
  },
  flimpTemplateID: null,
};

// Query Parameter Function
export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const getVideoParameter = (name, url) => {
  if (!url) url = url;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
// Update store as per element modifications
export const overrideAllOfElementType = (
  layoutList,
  customElementName,
  itemFirst,
  itemSecond,
  itemThird
) => {
  return layoutList.map((layout) => {
    return [
      layout[0],
      layout[1].map((item, itemIndex) => {
        if (item && item.customElementName == customElementName) {
          itemFirst(item);
          return item;
        }
        if (item && (item.data == "Row" || item.data == "Accordion")) {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem, colItemIndex) => {
              if (colItem.customElementName == customElementName) {
                itemSecond(colItem);
                return colItem;
              } else if (colItem.data == "Row" || colItem.data == "Accordion") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map(
                    (colItemNested, colItemNestedIndex) => {
                      if (
                        colItemNested.customElementName == customElementName
                      ) {
                        itemThird(colItemNested);
                        return colItemNested;
                      }
                      return colItemNested;
                    }
                  );
                });
              }
              return colItem;
            });
          });
        }

        return item;
      }),
    ];
  });
};
export const overrideAllButtons = (
  layoutList,
  itemFirst,
  itemSecond,
  itemThird
) => {
  return layoutList.map((layout) => {
    return [
      layout[0],
      layout[1].map((item, itemIndex) => {
        if (item && item.data == "BUTTON") {
          itemFirst(item);
          return item;
        }
        if (item && (item.data == "Row" || item.data == "Accordion")) {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem, colItemIndex) => {
              if (colItem && colItem.data == "BUTTON") {
                itemSecond(colItem);
                return colItem;
              } else if (colItem.data == "Row" || colItem.data == "Accordion") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map(
                    (colItemNested, colItemNestedIndex) => {
                      if (colItemNested && colItemNested.data == "BUTTON") {
                        itemThird(colItemNested);
                        return colItemNested;
                      }
                      return colItemNested;
                    }
                  );
                });
              }
              return colItem;
            });
          });
        }

        return item;
      }),
    ];
  });
};

export const UpdateLayout = (layout, ID, itemFirst, itemSecond, itemThird) => {
  return layout.map((item, itemIndex) => {
    if (item && item.id == ID) {
      itemFirst(item);
      return item;
    }
    if (item && (item.data == "Row" || item.data == "Accordion")) {
      Object.keys(item.columns).map((col, colIndex) => {
        return item.columns[col].map((colItem, colItemIndex) => {
          if (colItem.id == ID) {
            itemSecond(colItem);
            return colItem;
          } else if (colItem.data == "Row" || colItem.data == "Accordion") {
            Object.keys(colItem.columns).map((colNested, colIndex) => {
              return colItem.columns[colNested].map(
                (colItemNested, colItemNestedIndex) => {
                  if (colItemNested.id == ID) {
                    itemThird(colItemNested);
                    return colItemNested;
                  }
                  return colItemNested;
                }
              );
            });
          }
          return colItem;
        });
      });
    }

    return item;
  });
};

export const IDFilter = (layout, itemFirst, itemSecond, itemThird) => {
  return layout.map((item, itemIndex) => {
    if (item) {
      if ((item && item.data == "Row") || item.data == "Accordion") {
        Object.keys(item.columns).map((col, colIndex) => {
          return item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.data == "Row" || item.data == "Accordion") {
              Object.keys(colItem.columns).map((colNested, colIndex) => {
                return colItem.columns[colNested].map(
                  (colItemNested, colItemNestedIndex) => {
                    itemThird(colItemNested);
                    return colItemNested;
                  }
                );
              });
            }
            itemSecond(colItem);
            return colItem;
          });
        });
      }
      itemFirst(item);
      return item;
    }
  });
};

export const PushWithID = (layout) => {
  return layout.map((item, itemIndex) => {
    if ((item && item.data == "Row") || item.data == "Accordion") {
      Object.keys(item.columns).map((col, colIndex) => {
        return item.columns[col].map((colItem, colItemIndex) => {
          if (colItem.data == "Row" || colItem.data == "Accordion") {
            Object.keys(colItem.columns).map((colNested, colIndex) => {
              return colItem.columns[colNested].map(
                (colItemNested, colItemNestedIndex) => {
                  colItemNested.id = "F" + shortid();
                  return colItemNested;
                }
              );
            });
          }
          colItem.id = "F" + shortid();
          return colItem;
        });
      });
    }
    item.id = "F" + shortid();
    return item;
  });
};

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};
export const ValidateIfValueNumber = (inputValue) => {
  const isNumber = /^[0-9]*$/;
  const notInitZero = /^0[0-9].*$/;

  if (
    isNumber.test(inputValue) &&
    inputValue !== "" &&
    notInitZero.test(inputValue) !== true &&
    inputValue >= 0
  ) {
    return inputValue;
  }
};

export const steps = [
  {
    content: (
      <React.Fragment>
        <h5>Let's start the Flimp creative studio tour!</h5>
      </React.Fragment>
    ),
    placement: "center",
    locale: { skip: "SKIP" },
    target: "body",
  },
  {
    target: ".first-step",
    content: (
      <React.Fragment>
        <ul>
          <li>Add background Color or Image.</li>
          <li>Add template default font family.</li>
          <li>Container width options in pixel or percentage.</li>
          <li>Define colors globally for template.</li>
        </ul>
      </React.Fragment>
    ),
    placement: "right",
  },
  {
    target: ".second-step",
    content:
      "Utilize previously saved blocks and templates to construct your microsites with ease and efficiency.",
    placement: "right",
  },
  {
    target: ".third-step",
    content: "Add elements by dragging and dropping them into the canvas area.",
    placement: "right",
  },

  {
    target: ".fourth-step",
    content: "Add another page to your microsite.",
    placement: "right",
  },
  {
    target: ".fifth-step",
    content:
      "You can upload Images/Videos/Files to your content library and access previously uploaded content. ",
    placement: "right",
  },

  {
    target: ".sixth-step",
    content:
      "Preview what the microsite will look like when it is finished and outside of the editing view.",
    placement: "right",
  },
  {
    target: ".seventh-step",
    content: (
      <React.Fragment>
        <p>You can save your changes here whether it be:</p>
        <ul>
          <li>The entire microsite.</li>
          <li>A block for later use as a small preset section.</li>
          <li>A Template for later use as an entire page. </li>
        </ul>
      </React.Fragment>
    ),
    placement: "right",
  },
  {
    target: ".eighth-step",
    content: "Enable Full Screen Mode.",
    placement: "right",
  },
  {
    target: ".ninth-step",
    content: "You can review your site in desktop and mobile views.",
    placement: "right",
  },
  {
    target: ".tenth-step",
    content: "You can Undo and Redo actions performed in the editor.",
    placement: "right",
  },
  {
    target: ".eleventh-step",
    content: (
      <React.Fragment>
        <p>Edit the Navigation Header styles and alignment as well as:</p>
        <ul>
          <li>Add and remove pages.</li>
          <li>Toggle hamburger menu on and off.</li>
          <li>Toggle search options on and off. </li>
        </ul>
      </React.Fragment>
    ),
    placement: "right",
  },
  {
    target: ".twelth-step",
    content: "Exit and create a new microsite with this option.",
    placement: "right",
  },
  {
    target: ".thirteenth-step",
    content:
      "Select and edit multiple versions of the microsite through its edit history.",
    placement: "right",
  },
  {
    target: ".fourteenth-step",
    content: "Check microsite version, roll back, or fast forward.",
    placement: "right",
  },
  {
    target: ".fifteenth-step",
    content: "Customize and Add Global Style Components",
    placement: "right",
  },
  {
    target: ".sixteenth-step",
    content: "View and edit the site title and description.",
    placement: "right",
  },
  {
    target: "body",
    content: (
      <React.Fragment>
        <p>Now it is time to begin creating your microsite.</p>
        <p>Let's get started!</p>
      </React.Fragment>
    ),
    placement: "center",
  },
];
export const ValidURL = (str) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

export const getStyle = (el, styleProp) => {
  var value,
    defaultView = (el.ownerDocument || document).defaultView;
  // W3C standard way:
  if (defaultView && defaultView.getComputedStyle) {
    // sanitize property name to css notation
    // (hypen separated words eg. font-Size)
    styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
    return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  } else if (el.currentStyle) {
    // IE
    // sanitize property name to camelCase
    styleProp = styleProp.replace(/\-(\w)/g, function (str, letter) {
      return letter.toUpperCase();
    });
    value = el.currentStyle[styleProp];
    // convert other units to pixels on IE
    if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
      return (function (value) {
        var oldLeft = el.style.left,
          oldRsLeft = el.runtimeStyle.left;
        el.runtimeStyle.left = el.currentStyle.left;
        el.style.left = value || 0;
        value = el.style.pixelLeft + "px";
        el.style.left = oldLeft;
        el.runtimeStyle.left = oldRsLeft;
        return value;
      })(value);
    }
    return value;
  }
};
export const css2obj = (style) => {
  var result = {},
    attributes = style.split(";"),
    firstIndexOfColon,
    i,
    key,
    value;
  for (i = 0; i < attributes.length; i++) {
    firstIndexOfColon = attributes[i].indexOf(":");
    key = attributes[i].substring(0, firstIndexOfColon);
    value = attributes[i].substring(firstIndexOfColon + 1);

    key = key.replace(/ /g, "");
    if (key.length < 1) {
      continue;
    }

    if (value[0] === " ") {
      value = value.substring(1);
    }

    if (value[value.length - 1] === " ") {
      value = value.substring(0, value.length - 1);
    }

    result[key] = value;
  }

  return result;
};

export const replaceNode = (s, start, end, substitute) => {
  return s.substring(0, start) + substitute + s.substring(end);
};

// var str = "this is a string";
// var newString = replaceRange(str, 0, 4, "that"); // "that is a string"
export const ConvTextChar = (str) => {
  let c = {
    "’": "'",
    // "&#035;": "",
    "•": "&bull;",
    "—": "-",
  };
  return str.replace(/[’•—]/g, function (s) {
    return c[s];
  });
};
const ConvTextCharInMap = (str) => {
  let c = {
    "’": "'",
    // "&#035;": "",
    "•": "&bull;",
  };
  return str.replace(/[’•]/g, function (s) {
    return c[s];
  });
};
export const ConvEnDash = (str) => {
  let c = {
    "–": "&endash;",
  };
  return str.replace(/[–]/g, function (s) {
    return c[s];
  });
};

export const ConvertTextContent = (
  layout,
  itemFirst,
  itemSecond,
  itemThird
) => {
  return layout.map((item, itemIndex) => {
    if (item && item.data == "TEXT") {
      itemFirst(item);
      ConvTextCharInMap(item.text);
      return item;
    }
    if ((item && item.data == "Row") || item.data == "Accordion") {
      Object.keys(item.columns).map((col, colIndex) => {
        return item.columns[col].map((colItem, colItemIndex) => {
          if (colItem.data == "TEXT") {
            itemSecond(colItem);
            ConvTextCharInMap(colItem.text);
            return colItem;
          } else if (colItem.data == "Row" || item.data == "Accordion") {
            Object.keys(colItem.columns).map((colNested, colIndex) => {
              return colItem.columns[colNested].map(
                (colItemNested, colItemNestedIndex) => {
                  if (colItemNested.data == "TEXT") {
                    itemThird(colItemNested);
                    ConvTextCharInMap(colItemNested.text);
                    return colItemNested;
                  }
                  return colItemNested;
                }
              );
            });
          }
          return colItem;
        });
      });
    }
    return item;
  });
};

export const createClass = (selector, style) => {
  if (!document.styleSheets) return;
  if (document.getElementsByTagName("head").length == 0) return;

  let styleSheet, mediaType;
  const styleSheets = Array.from(document.styleSheets).filter(
    (styleSheet) =>
      !styleSheet.href ||
      (styleSheet.href.startsWith(window.location.origin) &&
        !styleSheet.href.includes("skins/ui/oxide/skin.min.css") &&
        !styleSheet.href.includes("skins/ui/oxide/content.inline.min.css"))
  );
  for (let style of styleSheets) {
    if (style instanceof CSSStyleSheet && style.cssRules) {
      for (let i = 0; i < style.cssRules.length; i++) {
        if (style.cssRules[i].selectorText == selector) style.removeRule(i);
      }
    }
  }
  if (styleSheets.length > 0) {
    for (let i = 0, l = styleSheets.length; i < l; i++) {
      if (styleSheets[i].disabled) continue;
      let media = styleSheets[i].media;
      mediaType = typeof media;

      if (mediaType === "string") {
        if (media === "" || media.indexOf("screen") !== -1) {
          styleSheet = styleSheets[i];
        }
      } else if (mediaType == "object") {
        if (
          media.mediaText === "" ||
          media.mediaText.indexOf("screen") !== -1
        ) {
          styleSheet = styleSheets[i];
        }
      }

      if (typeof styleSheet !== "undefined") break;
    }
  }

  if (typeof styleSheet === "undefined") {
    var styleSheetElement = document.createElement("style");
    styleSheetElement.type = "text/css";
    document.getElementsByTagName("head")[0].appendChild(styleSheetElement);

    for (let i = 0; i < styleSheets.length; i++) {
      if (styleSheets[i].disabled) {
        continue;
      }
      styleSheet = styleSheets[i];
    }

    mediaType = typeof styleSheet.media;
  }

  if (mediaType === "string") {
    for (let i = 0, l = styleSheet.rules.length; i < l; i++) {
      if (
        styleSheet.rules[i].selectorText &&
        styleSheet.rules[i].selectorText.toLowerCase() == selector.toLowerCase()
      ) {
        styleSheet.rules[i].style.cssText = style;
        return;
      }
    }
    styleSheet.addRule(selector, style);
  } else if (mediaType === "object") {
    let styleSheetLength = styleSheet.cssRules ? styleSheet.cssRules.length : 0;
    for (let i = 0; i < styleSheetLength; i++) {
      if (
        styleSheet.cssRules[i].selectorText &&
        styleSheet.cssRules[i].selectorText.toLowerCase() ==
          selector.toLowerCase()
      ) {
        styleSheet.cssRules[i].style.cssText = style;
        return;
      }
    }
    styleSheet.insertRule(selector + "{" + style + "}", styleSheetLength);
  }
};

export const hexToRgbA = (hex) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",1)"
    );
  }
  throw new Error("Bad Hex");
};

// Custom column layouts desk width percent. In decimals to fit grid guide.
export const columnLayouts = [
  {
    id: 1,
    colmLayout: [12, 0, 0, 0, 0, 0],
    deskWidth: [100],
  },
  {
    id: 2,
    colmLayout: [6, 6, 0, 0, 0, 0],
    deskWidth: [50, 50],
  },
  {
    id: 3,
    colmLayout: [4, 4, 4, 0, 0, 0],
    deskWidth: [33.33, 33.33, 33.33],
  },
  {
    id: 4,
    colmLayout: [3, 3, 3, 3, 0, 0],
    //deskWidth: [24.6667, 24.6667, 24.6667, 24.6667]
    deskWidth: [25, 25, 25, 25],
  },
  {
    id: 5,
    colmLayout: [2, 2, 2, 2, 2, 0],
    deskWidth: [20, 20, 20, 20, 20],
  },
  {
    id: 6,
    colmLayout: [2, 2, 2, 2, 2, 2],
    deskWidth: [
      16.666667, 16.666667, 16.666667, 16.666667, 16.666667, 16.666667,
    ],
  },
  {
    id: 7,
    colmLayout: [4, 8, 0, 0, 0, 0],
    //deskWidth: [33.1667, 66.8333]
    deskWidth: [33.3333, 66.6667],
  },
  {
    id: 8,
    colmLayout: [8, 4, 0, 0, 0, 0],
    // deskWidth: [66.8333, 33.1667]
    deskWidth: [66.6666, 33.3337],
    //deskWidth: [67, 33.184]
  },
  {
    id: 9,
    colmLayout: [3, 9, 0, 0, 0, 0],
    //deskWidth: [24.6667, 75.3333]
    deskWidth: [25, 75],
  },
  {
    id: 10,
    colmLayout: [9, 3, 0, 0, 0, 0],
    //deskWidth: [75.3333, 24.6667]
    deskWidth: [75, 25],
  },
  {
    id: 11,
    colmLayout: [2, 10, 0, 0, 0, 0],
    //deskWidth: [16.25, 83.75]
    deskWidth: [16.6667, 83.3333],
  },
  {
    id: 12,
    colmLayout: [10, 2, 0, 0, 0, 0],
    //deskWidth: [83.75, 16.25]
    deskWidth: [83.3333, 16.6667],
  },
  {
    id: 13,
    colmLayout: [3, 6, 3, 0, 0, 0],
    //deskWidth: [24.6667, 50, 24.6667]
    deskWidth: [25, 50, 25],
  },
  {
    id: 14,
    colmLayout: [2, 8, 2, 0, 0, 0],
    deskWidth: [16.6667, 66.6666, 16.6667],
  },
  {
    id: 15,
    colmLayout: [3, 3, 6, 0, 0, 0],
    //deskWidth: [24.6667, 24.6667, 50]
    deskWidth: [25, 25, 50],
  },
  {
    id: 16,
    colmLayout: [6, 3, 3, 0, 0, 0],
    //deskWidth: [50, 24.6667, 24.6667]
    deskWidth: [50, 25, 25],
  },
  {
    id: 17,
    colmLayout: [2, 2, 8, 0, 0, 0],
    // deskWidth: [16.666667, 16.6664667, 68.9]
    deskWidth: [16.6667, 16.6667, 66.6666],
  },
  {
    id: 18,
    colmLayout: [8, 2, 2, 0, 0, 0],
    // deskWidth: [68.9, 16.666667, 16.666667]
    deskWidth: [66.6666, 16.6667, 16.6667],
  },
  {
    id: 19,
    colmLayout: [2, 2, 2, 6, 0, 0],
    //deskWidth: [16.25, 16.25, 16.25, 50]
    deskWidth: [16.6667, 16.6666, 16.6667, 50],
  },
  {
    id: 20,
    colmLayout: [6, 2, 2, 2, 0, 0],
    //deskWidth: [50, 16.25, 16.25, 16.25]
    deskWidth: [50, 16.6667, 16.6666, 16.6666],
  },
  //new layouts
  {
    id: 21,
    colmLayout: [1, 1, 1, 9, 0, 0],
    deskWidth: [8.3333, 8.3333, 8.3333, 75],
  },
  {
    id: 22,
    colmLayout: [9, 1, 1, 1, 0, 0],
    deskWidth: [75, 8.3333, 8.3333, 8.3333],
  },
  {
    id: 23,
    colmLayout: [1, 1, 10, 0, 0, 0],
    deskWidth: [8.335, 8.335, 83.33],
  },
  {
    id: 24,
    colmLayout: [10, 1, 1, 0, 0, 0],
    deskWidth: [83.33, 8.335, 8.335],
  },
  {
    id: 25,
    colmLayout: [1, 11, 0, 0, 0, 0],
    deskWidth: [8.33, 91.67],
  },
  {
    id: 26,
    colmLayout: [11, 1, 0, 0, 0, 0],
    deskWidth: [91.67, 8.33],
  },

  // unaligned layout
  // {
  //   id: 21,
  //   colmLayout: [1, 1, 1, 9, 0, 0],
  //   deskWidth: [10, 10, 10, 70]
  // },
  // {
  //   id: 22,
  //   colmLayout: [9, 1, 1, 1, 0, 0],
  //   deskWidth: [70, 10, 10, 10]
  // },
  // {
  //   id: 23,
  //   colmLayout: [1, 1, 10, 0, 0, 0],
  //   deskWidth: [10, 10, 80]
  // },
  // {
  //   id: 24,
  //   colmLayout: [10, 1, 1, 0, 0, 0],
  //   deskWidth: [80, 10, 10]
  // },
  // {
  //   id: 25,
  //   colmLayout: [1, 11, 0, 0, 0, 0],
  //   deskWidth: [10, 90]
  // },
  // {
  //   id: 26,
  //   colmLayout: [11, 1, 0, 0, 0, 0],
  //   deskWidth: [90, 10]
  // },
];

export const columnGutterDivideValue = {
  100: 1,
  50: 2,
  33.33: 1.5,
  25: 1.33,
  20: 1.25,
  16.67: 1.2,
  66.67: 3,
  75: 3.99,
  83.33: 6,
  8.33: 1.09,
  8.34: 1.09,
  91.67: 12,
  // "80": 6,
  // "10": 1.09,
  // "90": 12,
  // "70": 4
};

export const isFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};

export const replacePX = (value) => {
  if (typeof value === "string" && value.indexOf("px") > -1) {
    value = value.replace("px", "");
  }
  return value;
};

// RESET STARTS
export const resetText = (textVal, property, tag, shortID) => {
  var myString = textVal;

  let elementID = "F" + shortID;
  var divElement = document.createElement("div");
  divElement.id = elementID;

  divElement.innerHTML = myString;
  if (divElement.getElementsByTagName(tag).length > 0) {
    var elements = divElement.getElementsByTagName(tag);

    for (var i = 0; i < elements.length; i++) {
      // remove the style attribute enterily if it contains font-size property
      if ((elements[i].getAttribute("style") || "").includes(property)) {
        elements[i].style.removeProperty("font-family");
        elements[i].style.removeProperty("font-size");
        elements[i].style.removeProperty("line-height");
        elements[i].style.removeProperty("background-color");
        elements[i].style.removeProperty("color");
        elements[i].style.removeProperty("margin-bottom");
        elements[i].style.removeProperty("padding-bottom");
      }
    }
  }
  // loop through ALL DOM elements insidie the divElement
  return divElement.innerHTML;
};

export const resetTextAndSave = (
  property,
  tag,
  layoutListArray,
  layoutArray,
  pushLayoutArray,
  shortID,
  replace_microsite,
  layoutTitle,
  selectedOverrideFont
) => {
  const layoutList = cloneDeep(layoutListArray);
  const listPages = layoutList.map((layout) => {
    layout[1].map((item, itemIndex) => {
      if (item && item.data == `TEXT`) {
        item.text = resetText(item.text, property, tag, shortID);
        item.style.fontFamily = selectedOverrideFont;
        return item;
      }
      if ((item && item.data == "Row") || item.data == "Accordion") {
        Object.keys(item.columns).map((col, colIndex) => {
          return item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.data == `TEXT`) {
              colItem.text = resetText(colItem.text, property, tag, shortID);
              colItem.style.fontFamily = selectedOverrideFont;
              return colItem;
            } else if (colItem.data == "Row" || item.data == "Accordion") {
              Object.keys(colItem.columns).map((colNested, colIndex) => {
                return colItem.columns[colNested].map(
                  (colItemNested, colItemNestedIndex) => {
                    if (colItemNested.data == `TEXT`) {
                      colItemNested.text = resetText(
                        colItemNested.text,
                        property,
                        tag,
                        shortID
                      );
                      colItemNested.style.fontFamily = selectedOverrideFont;
                      return colItemNested;
                    }
                    return colItemNested;
                  }
                );
              });
            }
            return colItem;
          });
        });
      }
      return item;
    });
    return layout;
  });

  replace_microsite(listPages);
  const layout = cloneDeep(layoutArray);
  const newLayout = layout.map((item, itemIndex) => {
    if (item && item.data == `TEXT`) {
      item.text = resetText(item.text, property, tag, shortID);
      item.style.fontFamily = selectedOverrideFont;

      return item;
    }
    if ((item && item.data == "Row") || item.data == "Accordion") {
      Object.keys(item.columns).map((col, colIndex) => {
        return item.columns[col].map((colItem, colItemIndex) => {
          if (colItem.data == `TEXT`) {
            colItem.text = resetText(colItem.text, property, tag, shortID);
            colItem.style.fontFamily = selectedOverrideFont;

            return colItem;
          } else if (colItem.data == "Row" || item.data == "Accordion") {
            Object.keys(colItem.columns).map((colNested, colIndex) => {
              return colItem.columns[colNested].map(
                (colItemNested, colItemNestedIndex) => {
                  if (colItemNested.data == `TEXT`) {
                    colItemNested.text = resetText(
                      colItemNested.text,
                      property,
                      tag,
                      shortID
                    );
                    colItemNested.style.fontFamily = selectedOverrideFont;

                    return colItemNested;
                  }
                  return colItemNested;
                }
              );
            });
          }
          return colItem;
        });
      });
    }
    return item;
  });
  pushLayoutArray(layoutTitle, newLayout);
};

//Type Validation
export const matchYoutubeUrl = (url) => {
  var p =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  var matches = url.match(p);
  if (matches) {
    return matches[1];
  }
  return false;
};
export const validateVimeoURL = (url) => {
  return /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/.test(url);
};

export const validationVimeoURL = (video_id) => {
  axios
    .get("https://api.vimeo.com/videos/" + video_id)
    .then(function (response) {})
    .catch(function (error) {})
    .then(function () {
      // always executed
    });
};

export const validateEmailFormat = (url) => {
  // const emailFormat = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
  const emailFormat = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return emailFormat.test(url);
};

export const validateURLFormat = (url) => {
  // const urlFormat =
  //   /^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/;
  // const urlFormat = /^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  // const urlFormat = /^(http|https):\/\/([a-z]*\.)?[a-z]*\.[a-z]{2,}(\/)?$/;
  // const urlFormat =
  //   /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
  const urlFormat =
    /(http(s)?):\/\/+[a-zA-Z0-9@:%._\+~#=-]{2,256}\.[a-zA-Z0-9@:%._\+~#=-]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/;
  return urlFormat.test(url);
};

export const validateFormId = (id) => {
  if (id.length > 31) {
    return "tooLong";
  }
  const formFormat = /[\\/\]\[\:*?]/g;

  if (formFormat.test(id)) {
    return "invalidChars";
  }
  if (id.length < 1) {
    return "tooShort";
  } else {
    return "validId";
  }
};
